var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgGiftbox02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 53,
    viewBox: "0 0 84 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ax6rhoaiwa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9252",
    style: {
      fill: "none"
    },
    d: "M0 0h84v53H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10164",
    style: {
      clipPath: "url(#ax6rhoaiwa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38590",
    d: "M94.063 16.477S100.023 0 114.987 0c2.081 1.075 8.73 7.164 5.407 22.924-7.484-2.866-26.33-6.447-26.33-6.447",
    transform: "translate(-52.063)",
    style: {
      fill: "#e32424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38591",
    d: "M60.295 16.477S54.335 0 39.37 0c-2.078 1.075-8.729 7.164-5.4 22.924 7.482-2.866 26.328-6.447 26.328-6.447",
    transform: "translate(-18.294)",
    style: {
      fill: "#e32424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38592",
    d: "M84 43.033a2.2 2.2 0 0 1-2.333 2.012H2.333A2.2 2.2 0 0 1 0 43.033V32.758a2.2 2.2 0 0 1 2.333-2.012h79.334A2.2 2.2 0 0 1 84 32.758z",
    transform: "translate(0 -17.15)",
    style: {
      fill: "#5e502b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38593",
    d: "M134.028 30.746H94.6v14.3h39.428a2.2 2.2 0 0 0 2.333-2.012V32.758a2.2 2.2 0 0 0-2.333-2.012",
    transform: "translate(-52.361 -17.15)",
    style: {
      fill: "#473d21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9248",
    transform: "translate(36.42 13.596)",
    style: {
      fill: "#e32424"
    },
    d: "M0 0h11.64v14.299H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9249",
    transform: "translate(42 13.596)",
    style: {
      fill: "#c41f1f"
    },
    d: "M0 0h6.06v14.299H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38594",
    d: "M38.417 58.031H11.45a2.2 2.2 0 0 0-2.333 2.012v25.326h29.3z",
    transform: "translate(-5.046 -32.369)",
    style: {
      fill: "#f9817d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9250",
    transform: "translate(33.371 25.662)",
    style: {
      fill: "#e32424"
    },
    d: "M0 0h8.868v27.338H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9251",
    transform: "translate(42 25.662)",
    style: {
      fill: "#c41f1f"
    },
    d: "M0 0h9.868v27.338H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38595",
    d: "M143.284 85.369V60.042a2.2 2.2 0 0 0-2.333-2.011h-26.488v27.338z",
    transform: "translate(-63.355 -32.369)",
    style: {
      fill: "#f9817d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGiftbox02);
export default __webpack_public_path__ + "static/media/img_giftbox02.72b304314c32c47b8aff4442bcf4e137.svg";
export { ForwardRef as ReactComponent };